import { axiosAPI } from 'utils';

export default { 
  async createStripePaymentIntent(
    amount, 
    familyId, 
    paymentMethodId, 
    paymentMethodCard, 
    email, 
    customerId = '', 
    repeat = false,
    currency = 'USD'
    ) {
    try {
      const payload = { 
        amount, 
        familyId, 
        paymentMethodId, 
        paymentMethodCard,
        email,
        customerId,
        repeat,
        currency
      };
      console.log('[stripeAPI][create-payment-intent][payload]', payload);
      const response = await axiosAPI.post("/api/stripe/create-payment-intent", payload);
      console.log('[stripeAPI][create-payment-intent][response]', response.data);
      return response.data;
    } catch (error) {
      console.error('Stripe payment intent error:', error);
      return error.response?.data || { error: error.message };
    }
  },
  async createStripeSubscription(
    email, 
    paymentMethodId, 
    priceId,
    paymentMethodCard,
    familyId,
    prepaidDaysRemaining,
    customerId = '', 
    repeat = false
    ) {
    try {
      const response = await axiosAPI.post("/api/stripe/create-subscription", { 
        email, 
        paymentMethodId, 
        priceId,
        paymentMethodCard,
        familyId,
        prepaidDaysRemaining,
        customerId,
        repeat
      });
      return response.data;
    } catch (error) {
      console.error('Stripe payment intent error:', error);
      return error.response?.data || { error: error.message };
    }
  },
  async removeStripeSubscription(subscriptionId, familyId) {
    try {
      const response = await axiosAPI.post("/api/stripe/cancel-subscription", { 
        subscriptionId,
        familyId
      });
      return response.data;
    } catch (error) {
      console.error('Stripe payment intent error:', error);
      return error.response?.data || { error: error.message };
    }
  },
  async createFamilyLocalPaySession(payload) {
    try {
      console.log('[stripeAPI][family-local-pay][payload]', payload);
      const response = await axiosAPI.post('/api/stripe-local-pay/family-session', payload);
      console.log('[stripeAPI][family-local-pay][response]', response.data);
      return response.data;
    } catch (error) {
      console.error('Stripe local pay family session error:', error);
      return error.response?.data || { error: error.message };
    }
  },
  async verifyFamilyLocalPay(provider, reference) {
    try {
      const normalizedProvider = String(provider || 'stripe').trim().toLowerCase();
      const normalizedReference = encodeURIComponent(String(reference || '').trim());
      console.log('[stripeAPI][family-local-pay][verify]', {
        provider: normalizedProvider,
        reference,
      });
      const response = await axiosAPI.get(
        `/api/stripe-local-pay/verify/${normalizedProvider}/${normalizedReference}`
      );
      console.log('[stripeAPI][family-local-pay][verify][response]', response.data);
      return response.data;
    } catch (error) {
      console.error('Local pay family verify error:', error);
      return error.response?.data || { error: error.message };
    }
  },
  async verifyFamilyLocalPaySession(sessionId) {
    try {
      console.log('[stripeAPI][family-local-pay][verify][sessionId]', sessionId);
      const response = await axiosAPI.get(`/api/stripe-local-pay/verify-family-session/${sessionId}`);
      console.log('[stripeAPI][family-local-pay][verify][response]', response.data);
      return response.data;
    } catch (error) {
      console.error('Stripe local pay family verify error:', error);
      return error.response?.data || { error: error.message };
    }
  },
}

